import { z } from 'zod';

const booleanVar = z
  .enum(['true', 'false'])
  .transform((v) => v === 'true')
  .default(false);

const schema = z.object({
  // API
  VITE_API_BASE: z.string().default('/api'),
  VITE_API_PROXY_TARGET: z
    .string()
    .default(
      'https://rope-staging-api-hcbvc9gvgbh9d0br.swedencentral-01.azurewebsites.net',
    ),

  // OIDC / Identity Server
  VITE_OIDC_AUTHORITY: z.string().default('/api/identityserver'),
  VITE_OIDC_PROXY_TARGET: z
    .string()
    .default(
      'https://rope-staging-identity-server-a0fsf7ekgfbra5gy.swedencentral-01.azurewebsites.net',
    ),
  VITE_OIDC_CLIENT_ID: z.string().default('WebClient'),
  VITE_OIDC_CLIENT_SECRET: z.string().default('secret'),
  VITE_APP_URL: z.string().default('http://localhost:3000'),

  // Dev flags
  VITE_USE_MOCKED_USER: booleanVar,
  VITE_DETECT_MUTATIONS: booleanVar,
  VITE_LOG_SAGA_TIME: booleanVar,
  VITE_SLOW_DOWN_SAGA: booleanVar,
  VITE_REACT_STRICT_MODE: booleanVar,

  // Vite built-in
  DEV: z.boolean().default(false),
});

export const env = schema.parse(import.meta.env);
